module.exports = {
      id: "linkedin-usage",
      viewBox: "0 0 22 22",
      url: __webpack_public_path__ + "img/icons.0526cd7f.svg#linkedin-usage",
      toString: function () {
        return this.url;
      }
    }